/**
 * Maps TicketPackages ticket rows into recommendation-engine inventory.
 *
 * Engine row: { day, k, sec, row, p, av }
 * Ticket fields (API): location_slug/slug, small_date/date, sector, price, soldout, rows
 */

function parsePrice(price) {
  if (price == null || price === '') return 0;
  if (typeof price === 'number' && Number.isFinite(price)) return price;
  const n = Number(String(price).replace(/[^\d.,-]/g, '').replace(',', '.'));
  return Number.isFinite(n) ? n : 0;
}

/** Prefer slug fields; never use display `location` ("Camarote Mar") as map key. */
function ticketSlug(ticket) {
  return (
    ticket.location_slug ||
    ticket.slug ||
    ticket.type ||
    ''
  );
}

function ticketDay(ticket) {
  return String(ticket.small_date || ticket.date || ticket.day || '').slice(0, 10);
}

function availability(ticket) {
  if (ticket.available != null && ticket.available !== '') {
    const av = Number(ticket.available);
    if (Number.isFinite(av)) return Math.max(0, av);
  }
  const soldout = Number(ticket.soldout);
  if (soldout === 1 || soldout === 4) return 0;
  if (ticket.soldout === true) return 0;
  return 1;
}

function baseRow(ticket, k) {
  const row = {
    day: ticketDay(ticket),
    k,
    sec: String(ticket.sector != null ? ticket.sector : ''),
    row: null,
    p: parsePrice(ticket.price != null ? ticket.price : ticket.price_ref),
    av: availability(ticket),
    id: ticket.id != null ? ticket.id : null,
  };
  if (ticket.sku_id) row.skuId = String(ticket.sku_id);
  return row;
}

function expandRows(ticket, k) {
  const rows = ticket.rows;
  if (!rows) return [baseRow(ticket, k)];

  if (Array.isArray(rows)) {
    const out = [];
    for (const entry of rows) {
      if (entry == null) continue;
      if (typeof entry === 'string') {
        out.push({ ...baseRow(ticket, k), row: entry });
        continue;
      }
      const rowId = entry.row || entry.id || entry.name;
      if (!rowId) continue;
      const rowTicket = { ...ticket, ...entry, row: rowId };
      out.push({
        ...baseRow(rowTicket, k),
        row: String(rowId),
        p: parsePrice(entry.price != null ? entry.price : rowTicket.price),
        av: entry.available != null ? Math.max(0, Number(entry.available) || 0) : availability(rowTicket),
      });
    }
    return out.length ? out : [baseRow(ticket, k)];
  }

  if (typeof rows === 'string' && rows.trim()) {
    const letters = rows.match(/[A-Z]/gi);
    if (letters && letters.length > 1) {
      return letters.map((row) => ({ ...baseRow(ticket, k), row: row.toUpperCase() }));
    }
    return [{ ...baseRow(ticket, k), row: rows.trim() }];
  }

  return [baseRow(ticket, k)];
}

/**
 * @param {object[]} tickets
 * @param {Record<string, string>} slugToEngineKey location slug → engine catalog key
 * @returns {object[]}
 */
function ticketsToInventory(tickets, slugToEngineKey) {
  const map = slugToEngineKey || {};
  const out = [];

  for (const ticket of tickets || []) {
    if (!ticket) continue;
    const slug = ticketSlug(ticket);
    const k = map[slug];
    if (!k) continue;
    const day = ticketDay(ticket);
    if (!day) continue;

    for (const row of expandRows(ticket, k)) {
      if (!row.sec && row.row == null && row.p === 0 && row.av === 0) continue;
      out.push(row);
    }
  }

  return out;
}

module.exports = {
  ticketsToInventory,
  parsePrice,
};
